var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GlobalConstantsRegistry',{staticClass:"mt-4",attrs:{"hide-pagination-count":"","network":_vm.network,"constantsNumber":_vm.constantsNumber,"items-per-page":10,"updateable":false,"pageable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }